import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/storage';
const config = {
    apiKey: 'AIzaSyC95HftN017FkZ7gQc02DYhlL2POJq8BmA',
    authDomain: 'makingauthenticfriendships.firebaseapp.com',
    databaseURL: 'https://makingauthenticfriendships.firebaseio.com',
    projectId: 'makingauthenticfriendships',
    storageBucket: 'makingauthenticfriendships.appspot.com',
    messagingSenderId: '1008745928527',
    appId: '1:1008745928527:web:82eeb51bec1d54e3',
};
if (!firebase.apps.length) {
    firebase.initializeApp(config);
}

export default {
    install(Vue: any) {
        Vue.prototype.$firebase = firebase;
        Vue.prototype.$auth = firebase.auth();
        Vue.prototype.$firestore = firebase.firestore();
        Vue.prototype.$storage = firebase.storage();
        Vue.prototype.$functions = firebase.functions();
    },
};
